var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclesBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 811,
    height: 207,
    viewBox: "0 0 811 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5492 417.35C55.6737 288.916 136.382 161.391 264.816 132.516C393.251 103.64 520.775 184.348 549.651 312.783C578.526 441.217 497.818 568.742 369.384 597.617C240.949 626.493 113.425 545.784 84.5492 417.35Z",
    stroke: "url(#paint0_linear_733_51113)",
    strokeWidth: 54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5492 417.35C55.6737 288.916 136.382 161.391 264.816 132.516C393.251 103.64 520.775 184.348 549.651 312.783C578.526 441.217 497.818 568.742 369.384 597.617C240.949 626.493 113.425 545.784 84.5492 417.35Z",
    stroke: "url(#paint1_linear_733_51113)",
    strokeWidth: 54
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M771.2 266.323C771.2 141.31 669.857 39.9669 544.844 39.9669C419.831 39.9669 318.488 141.31 318.488 266.323C318.488 391.335 419.831 492.678 544.844 492.678C669.857 492.678 771.2 391.335 771.2 266.323Z",
    stroke: "url(#paint2_linear_733_51113)",
    strokeWidth: 78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.2 266.323C771.2 141.31 669.857 39.9669 544.844 39.9669C419.831 39.9669 318.488 141.31 318.488 266.323C318.488 391.335 419.831 492.678 544.844 492.678C669.857 492.678 771.2 391.335 771.2 266.323Z",
    stroke: "url(#paint3_linear_733_51113)",
    strokeWidth: 78
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_733_51113",
    x1: 375.306,
    y1: 623.96,
    x2: 258.894,
    y2: 106.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_733_51113",
    x1: 375.306,
    y1: 623.96,
    x2: 258.894,
    y2: 106.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_733_51113",
    x1: 544.844,
    y1: 531.678,
    x2: 544.844,
    y2: 0.966881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_733_51113",
    x1: 544.844,
    y1: 531.678,
    x2: 544.844,
    y2: 0.966881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesBottom);
export default __webpack_public_path__ + "static/media/circles-bottom.0fec7ef82ae84c3c762ff21ea9fe93b3.svg";
export { ForwardRef as ReactComponent };